module.exports = __webpack_public_path__ + "static/bg-ipad-hq-9c3c073ed299075fa031055f6862eefa.png";